import React, { useEffect, useState, useReducer } from 'react';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import FormControlLabel from '@mui/material/FormControlLabel';
import TextField from '@mui/material/TextField';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Switch from '@mui/material/Switch';
import { Box } from '@mui/system';
import { setSnackBarAlert, findAllRoles, caughtError } from '../../redux';
import getAppConfig from '../../config';
const config = getAppConfig();

const initialState = {
   roleName: '',
   active: false
}

const reducer = (state, action) => {
  return {
  ...state,
  ...action
  }
}

const EditForm = (props) => {

  const [state, updateState] = useReducer(reducer, initialState);
  const [loading, setLoading] = useState(true);
  const [btnDisabled, setBtnDisabled] = useState(true);
  const dispatch = useDispatch();

  const handleInputChange = (event) => {
    if(event.target.type === 'checkbox'){
      updateState({ [event.target.name]: event.target.checked });
    } else {
      updateState({ [event.target.name]: event.target.value });
    }
  }

  useEffect(() => {
    if(loading && props.modalDiaLogId && props.modalDiaLogId > 0) {
      let URL = `${config.api.URL}/role/${props.modalDiaLogId}`;
      axios.get(URL).then(response => {
        updateState({
          roleName: response.data.data.roleName,
          active: Boolean(response.data.data.active),
        })
        setBtnDisabled(false);
        setLoading(false);
      }).catch(error => {
        setLoading(false);
        console.log(error);
      })
    }
  }, [loading, props]);

  const handleSubmit = (event) => {
    event.preventDefault();

    if(state.roleName === '') {
      dispatch(setSnackBarAlert({
        openSnackBar: true,
        severity: 'error',
        message: `roleName is required`
      }));
      return false;
    }

    setBtnDisabled(true);
    axios.patch(`${config.api.URL}/role/${props.modalDiaLogId}`, state).then(response => {
      dispatch(setSnackBarAlert({
        openSnackBar: true,
        severity: 'success',
        message: `Success! ${state.roleName} role updated`
      }));

      dispatch(findAllRoles(props.filterInput));
      props.setOpen(false);
    }).catch(error => {
      setBtnDisabled(false);
      dispatch(caughtError(error));
    })

  }

  return (
    <form onSubmit={handleSubmit}>
      <DialogContent sx={{ marginTop: "-20px" }} >

        <TextField
          value={state.roleName}
          onChange={handleInputChange}
          name="roleName"
          label="Role Name"
          margin="dense"
          type="text"
          fullWidth
          variant="outlined"
          required
        />

        <Box>
          <FormControlLabel className="float-end" control={<Switch name="active" checked={state.active} onChange={handleInputChange} />} label="Active" labelPlacement="start" />
        </Box>

      </DialogContent>
      <DialogActions>
        <button className="btn btn-secondary" onClick={ (e) => {
            e.preventDefault();
            props.setOpen(false);
          } }>Cancel</button>
        <button disabled={btnDisabled} type="submit" className="btn btn-primary" >Update Role</button>
      </DialogActions>
    </form>
  )

}

export default EditForm;
